export function startCase(input: string): string {
  return (
    input
      // Replace underscores and hyphens with a space
      .replace(/[_-]+/g, " ")
      // Insert a space between a lowercase letter/digit and an uppercase letter (e.g. "fooBar" → "foo Bar")
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      // Remove any punctuation (except spaces and word characters)
      .replace(/[^\w\s]+/g, "")
      .trim()
      // Split into words using one or more whitespace characters as separator
      .split(/\s+/)
      // Capitalize each word: first letter uppercase, rest lowercase
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      // Join back into a single string
      .join(" ")
  );
}
